<template>
  <div
    v-loading="loading"
    class="product"
  >
    <div class="table">
      <div class="table-header">
        <span class="header-title"><i class="el-icon-warning"></i>个人可展示的产品需要从公司的产品库中挑选，公司产品库仅管理员可编辑。</span>
        <el-button
          type="primary"
          size="small"
          @click="openDialog"
        >
          <i class="el-icon-plus el-icon-left"></i>选择产品
        </el-button>
      </div>
      <div class="table-body">
        <mk-table
          :data="tableData"
          style="width: 100%;"
          row-key="proName"
        >
          <el-table-column
            prop="proImg"
            label="产品图片"
            width="300px"
          >
            <template v-slot="scope">
              <div class="pro-img">
                <img
                  :src="scope.row.pictureArr[0]"
                  alt="error"
                  width="36"
                  height="36"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="产品名称"
          >
          </el-table-column>
          <el-table-column
            prop="introduction"
            label="产品简介"
          >
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <a
                slot="reference"
                href="javascript: void(0)"
                @click="productGet(scope.row.id)"
              >详情</a>
              <el-popover
                v-model="scope.row.popoverVisible"
                placement="top"
                width="200"
                trigger="click"
              >
                <div>
                  <div>移除后此产品不会在小程序端显示，是否移除？</div>
                  <el-button
                    size="mini"
                    @click="scope.row.popoverVisible = false"
                  >
                    取消
                  </el-button>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="productDelete(scope.row)"
                  >
                    移除
                  </el-button>
                </div>
                <a
                  slot="reference"
                  href="javascript: void(0)"
                  class="mr-l-5"
                >移除</a>
              </el-popover>
            </template>
          </el-table-column>
        </mk-table>
      </div>
      <div class="bottom-pagination">
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="选择产品"
      :visible.sync="dialog.choose"
      :append-to-body="true"
      width="1000px"
      class="drawer"
    >
      <div>
        <div class="choose-input">
          <mk-input
            v-model="drawerInput"
            placeholder="输入产品名称"
            width="180"
            @keyup.enter.native="dialogTableSearch(1)"
          >
            <i
              slot="suffix"
              class="el-icon-search el-input__icon"
              @click="dialogTableSearch(1)"
            ></i>
          </mk-input>
          <span class="total-product">共{{ drawerTotal }}个产品</span>
        </div>
        <div class="dialog-table">
          <mk-table
            ref="multipleTable"
            v-infinite-scroll="load"
            :infinite-scroll-immediate="false"
            :data="drawerTableData"
            :row-key="(row) => {return row.id}"
            class="dialog-table-product"
            header-row-class-name="dialog-table-product-header"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column label="产品图片">
              <template v-slot="scope">
                <img
                  :src="scope.row.pictureArr[0]"
                  alt="error"
                  width="36"
                  height="36"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="产品名称"
            >
            </el-table-column>
            <el-table-column
              prop="introduction"
              label="产品简介"
            >
            </el-table-column>
          </mk-table>
        </div>
        <div class="drawer-button">
          <span>已选中{{ chooseLength }}条</span>
          <div>
            <el-button
              size="small"
              @click="dialog.choose = false"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="addProduct"
            >
              添加
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="产品详情"
      :visible.sync="dialog.details"
      :append-to-body="true"
      width="1000px"
      class="details-drawer"
    >
      <div>
        <div>
          <el-row>
            <el-col
              :span="6"
              class="item-title"
            >
              产品名称：
            </el-col>
            <el-col :span="16">
              {{ productDetails.name }}
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="6"
              class="item-title"
            >
              产品图片：
            </el-col>
            <el-col :span="16">
              图图片
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="6"
              class="item-title"
            >
              产品简介：
            </el-col>
            <el-col :span="16">
              {{ productDetails.introduction }}
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="6"
              class="item-title"
            >
              产品详情：
            </el-col>
            <el-col :span="16">
              <div>
                {{ productDetails.content }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  name: 'Product',
  data () {
    return {
      // 表格数据
      tableData: [],
      // 当前页码
      currentPage: 1,
      // 分页总数
      total: 0,
      // 弹框中的输入框
      drawerInput: '',
      // 弹框数据
      drawerTableData: [],
      // 弹框
      dialog: {
        choose: false,
        details: false
      },
      // 弹框分页当前页
      drawerCurrentPage: 1,
      // 弹框分页总数
      drawerTotal: 10,
      // 弹框分页总页数
      drawerTotalPage: 1,
      // 详情弹窗
      detailsDrawer: false,
      // 是否第一次打开弹框
      fistOpen: true, // 是否是第一次打开
      // checkbox选择
      multipleSelection: [],
      // 是否正在请求
      loading: false,
      // 产品详情
      productDetails: {}
    }
  },
  computed: {
    chooseLength () {
      return this.multipleSelection.length
    }
  },
  mounted () {
    this.productMyListGet(1)
  },
  methods: {
    // 打开选择产品弹框
    openDialog () {
      this.dialog.choose = true
      this.fistOpen = true
      this.drawerTableData = []
      this.drawerCurrentPage = 1
      this.multipleSelection = []
      this.dialogTableSearch(1)
    },
    // 选择产品弹框搜索
    dialogTableSearch (page) {
      if (!page) {
        this.drawerCurrentPage = 1
      }
      let data = {
        page,
        keyword: this.drawerInput
      }
      this.productListGet(data)
    },
    // 关闭popover
    hidePopover (val) {
    },
    handleClose () {},
    drawerHandleCurrentChange () {},
    handleCurrentChange () {},
    // 移除
    async productDelete (data) {
      this.loading = true
      let res = await JINGTUIAPIS.ProductApi.productDelete({ id: data.id })
      this.loading = false
      if (res.success) {
        this.$message.success('产品移除成功')
        data.popoverVisible = false
        this.productMyListGet(this.currentPage)
      } else {
        this.$message.error('产品移除失败')
      }
    },
    // 多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 获取我的名片下的产品列表
    async productMyListGet (page) {
      this.loading = true
      let res = await JINGTUIAPIS.ProductApi.productMyListGet({ page })
      this.loading = false
      if (res.success) {
        this.tableData = res.data.data ? res.data.data : []
        this.currentPage = res.data.page
        this.total = res.data.total
      }
    },
    // 获取所有产品的列表
    async productListGet (data) {
      this.loading = true
      let res = await JINGTUIAPIS.ProductApi.productListGet({ ...data })
      this.loading = false
      if (res.success) {
        this.drawerTableData = res.data.list
        this.drawerTotal = res.data.total
        this.drawerTotalPage = Math.ceil(res.data.total / res.data.pageSize)
      }
    },
    // 获取产品详情
    async productGet (id) {
      this.loading = true
      let res = await JINGTUIAPIS.AllApi.productGet({
        id
      })
      this.loading = false
      if (res.success) {
        this.productDetails = res.data
        this.dialog.details = true
      }
    },
    // 添加产品
    async productMyProductPost (data) {
      this.loading = true
      let res = await JINGTUIAPIS.ProductApi.productMyProductPost({ ...data })
      this.loading = false
      if (res.success) {
        this.$message.success('添加成功')
        this.productMyListGet(1)
        this.dialog.choose = false
      } else {
        this.$message.error('添加失败')
      }
    },
    // 无线滚动加载
    load () {
      if (this.fistOpen) {
        this.fistOpen = !this.fistOpen
        return
      }
      if (this.drawerCurrentPage >= this.drawerTotalPage) {
        return
      }
      this.dialogTableSearch(++this.drawerCurrentPage)
    },
    // 添加产品
    addProduct () {
      let idList = []
      this.multipleSelection.forEach(item => {
        idList.push(item.id)
      })
      let data = {
        productIDArr: idList
      }
      this.productMyProductPost(data)
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  height: 100%;
  width: 100%;

  a {
    text-decoration: none;
    color: #009cff;
  }

  .mr-l-5 {
    margin-left: 5px;
  }

  .table {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 13px 20px;
    position: relative;

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-title {
        font-size: 13px;
        color: #595959;

        .el-icon-warning {
          font-size: 14px;
          color: #faad14;
        }
      }
    }

    .table-body {
      margin: 30px 0 60px;
      flex: 1;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .pro-img {
        display: flex;
        align-items: center;
      }

      .el-icon-rank {
        font-size: 30px;
      }
    }

    .bottom-pagination {
      position: absolute;
      padding: 0 20px 0 0;
      bottom: 0;
      height: 80px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}

.drawer {
  .dialog-table-product {
    width: 100%;
    overflow: auto;
    max-height: 500px;
  }

  /deep/ .el-dialog__body {
    padding: 0;
  }

  .choose-input,
  .dialog-table {
    padding: 20px 20px 0;
  }

  .choose-input {
    display: flex;
    justify-content: space-between;

    .total-product {
      color: #595959;
    }
  }

  .drawer-button {
    height: 56px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -2px 4px 0 rgba(5, 49, 38, 0.05);
    border: 1px solid rgba(232, 232, 232, 1);
    padding: 0 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .has-choosen {
      color: #8c8c8c;
      font-size: 13px;
    }
  }
}

.details-drawer {
  .details-drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item-title {
    text-align: right;
  }
}
</style>
